import { render, staticRenderFns } from "./CashRegistersReportsPage.vue?vue&type=template&id=76e94f90"
import script from "./CashRegistersReportsPage.vue?vue&type=script&lang=js"
export * from "./CashRegistersReportsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports